import { DismissibleTag, Inline, Stack } from 'canoe';
import { nanoid } from 'nanoid';
import React, { FormEvent, useCallback, useState } from 'react';
import styled from 'styled-components';

import { VariableForm } from 'craft/components/VariableEditor';
import { LinkVariable } from 'craft/rte/plugins/withLink/wrapLink';

const ShowMoreContainer = styled.div`
  margin: 8px;
`;

interface ManageVariablesProps {
  traits: { name: string }[];
  linkVariables: LinkVariable[];
  removeLinkVariable: (id: string) => void;
  onSubmit: (e: any) => void;
  onClose: () => void;
}

export const ManageVariables = ({
  onSubmit,
  traits,
  onClose,
  linkVariables,
  removeLinkVariable,
}: ManageVariablesProps) => {
  const [name, setName] = useState('');
  const [fallback, setFallback] = useState('');

  const variableOptions = traits.map((trait) => ({
    value: trait.name,
    label: trait.name,
  }));

  const handleSubmit = useCallback(
    (e: FormEvent) => {
      e.preventDefault();

      if (name !== '' && fallback !== '') {
        const id = nanoid(6);

        setName('');
        setFallback('');

        onSubmit({
          id,
          name,
          fallback,
        });
      }
    },
    [onSubmit, name, fallback],
  );

  return (
    <ShowMoreContainer>
      <Stack space="none">
        <Inline space="xs">
          {linkVariables.map((linkVariable) => (
            <DismissibleTag
              key={linkVariable.id}
              variant="contrast"
              text={linkVariable.id}
              label={`${linkVariable.name} (${linkVariable.fallback})`}
              onDismiss={() => removeLinkVariable(linkVariable.id)}
            />
          ))}
        </Inline>
        <VariableForm
          onSubmit={handleSubmit}
          name={name}
          setName={setName}
          options={variableOptions}
          fallback={fallback}
          setFallback={setFallback}
          onClose={onClose}
          submitText="Insert"
          cancelText="Done"
        />
      </Stack>
    </ShowMoreContainer>
  );
};
